module.exports = __webpack_public_path__ + "static/img/o9m0.7445525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/o9m/o9m0.jpg
// module id = /F/W
// module chunks = 1